import React from 'react'
import Tooltip from "@material-ui/core/Tooltip";
import phoneLogo from '../../../assets/cardEntryIcons/phone.svg';
import emailLogo from '../../../assets/cardEntryIcons/email.svg';
import keyLogo from '../../../assets/cardEntryIcons/key.svg';
import registerLogo from '../../../assets/cardEntryIcons/register.svg';
import claimLogo from '../../../assets/cardEntryIcons/hands_up.svg';
import documentLogo from '../../../assets/cardEntryIcons/document.svg';
import portabilityLogo from '../../../assets/cardEntryIcons/TransactionArrowGrey.svg';
import {colorGreen, colorRed, colorGrey, colorYellow} from "./utils"
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PublishIcon from '@material-ui/icons/Publish';
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from '@material-ui/icons/Clear';


export const getDictType = (status) => {
    switch(status){
        case "claim_portability":
            return "Portabilidade"
        case "registration":
            return "Cadastro"
        case "claim_ownership":
            return "Reivindicação"
        default:
            return status
    }
}

export const getDictKeyType = (status) => {
    switch(status){
        case "phone":
            return "Telefone"
        case "email":
            return "Email"
        case "cpf":
            return "CPF"
        case "cnpj":
            return "CNPJ"
        case "evp":
            return "EVP"
        default:
            return status
    }
}

export const getDictStatus = (status) => {
    switch(status){
        case "created":
            return "Criado"
        case "reproved":
            return "Reprovado"
        case "waiting_resolution":
            return "Esperando resolução da contraparte"
        case "cancelled_by_client":
            return "Cancelado pelo Cliente"
        case "cancelled_by_counterpart":
            return "Cancelado pela Contraparte"
        case "confirmed":
            return "Aprovado pela Contraparte"
        case "completed":
            return "Confirmado pelo Banco Central"
        default:
            return status
    }
}

export const getDictStatusColor = (status) => {
    switch(status){
        case "cancelled_by_client":
        case "cancelled_by_counterpart":
        case "reproved":
            return colorRed
        case "waiting_resolution":
            return colorYellow
        case "confirmed":
        case "completed":
            return colorGreen
        case "created":
        default:
            return colorGrey
    }
}

export const getDictStatusIcon = (status, icon_size_class, showTooltip=false) => {
    let circle_size
    let icon_size
    let icon_component
    let icon_backgroud_color = getDictStatusColor(status)
    if (icon_size_class === "big"){
        circle_size = ""
        icon_size = "45px"
    }
    else if (icon_size_class === "small"){
        circle_size = "small"
        icon_size = "18px"
    }
    else throw new Error("Please a new size is needed for setup")
    switch(status){
        case "waiting_resolution":
        case "created":            
            icon_component = <PublishIcon   style={{width:icon_size, height:icon_size}}/>
            break
        case "cancelled_by_client":
        case "cancelled_by_counterpart":
        case "reproved":
            icon_component = <ClearIcon  style={{width:icon_size, height:icon_size}}/>
            break       
        case "confirmed":
        case "completed":
            icon_component = <CheckIcon  style={{width:icon_size, height:icon_size}}/>
            break   
        default:
            icon_component = <HelpOutlineIcon  style={{width:icon_size, height:icon_size}}/>
            break   
    }
    if (showTooltip){
        return (
            <Tooltip title={<p className="tooltipText">{getDictStatus(status)}</p>}>
                <div className={["circle", circle_size].join(" ")} style={{backgroundColor: icon_backgroud_color}}>
                    {icon_component}
                </div>
            </Tooltip>
        )
    }
    else{
        return (
            <div className={["circle", circle_size].join(" ")} style={{backgroundColor: icon_backgroud_color}}>
                {icon_component}
            </div>
        )
    }
}

export const getKeyTypeIcon = (dict_key_type, dict_value) => {
    let logo = null
    switch(dict_key_type){
        case "phone":
            logo = phoneLogo
            break
        case "email":
            logo = emailLogo
            break
        case "cpf":
        case "cnpj":
            logo = documentLogo
            break
        case "evp":
        default:
            logo = keyLogo
            break 
    }
    return (
        <Tooltip title={<p className="tooltipText">{getDictKeyType(dict_key_type)}: {dict_value || ""}</p>}>
            <img style={{height:"20px"}} className="entryIconStyle" src={logo} alt="entryLogo Logo" />
        </Tooltip>
    ) 
}

export const getDictTypeIcon = (dict_type) => {
    let logo = null
    switch(dict_type){
        case "claim_portability":
            logo = portabilityLogo
            break
        case "registration":
            logo = registerLogo
            break
        case "claim_ownership":
            logo = claimLogo
            break
        default:
            logo = keyLogo
            break 
    }
    return (
      <Tooltip title={<p className="tooltipText">{getDictType(dict_type)}</p>}>
        <img style={{height:"20px"}} className="entryIconStyle" src={logo} alt="entryLogo Logo" />
      </Tooltip>
    ) 
}

export const getReasonDescription = (transaction) => {
    let last_index = (transaction.analysis_events || []).length ? ((transaction.analysis_events || []).length - 1) : 0
    return  ((((transaction.analysis_events || [])[last_index] || {}).decision_metadata || {}).reason_description || "-")
}
